export const HTML_TYPE = 'wix-draft-plugin-html';
